import { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { headerButtonClickedIs } from 'redux/header/header.slices';
import { quizRoutes } from 'types/quiz';

const HeaderButton = () => {
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const { t } = useTranslation('common');

  const dispatch = useDispatch();

  const buttonOptions = [
    { pathname: '/events', buttonText: t('common:add_event'), onClick: () => null },
    {
      pathname: '/quiz',
      buttonText: t('common:add_quizz'),
      onClick: () => history.push(quizRoutes.createQuizPath),
    },
    {
      pathname: '/daily-message',
      buttonText: t('common:add_daily_message'),
      onClick: () => dispatch(headerButtonClickedIs('DailyMessage')),
    },
  ];

  const buttonData = useMemo(
    () => buttonOptions.find(button => button.pathname === pathname),
    [pathname]
  );

  if (!buttonData) return;

  return (
    <button
      className={
        'btn nowrap border-none w-100 text-white rounded-full no-underline text-bold bg-primary ml-2'
      }
      onClick={buttonData.onClick}
    >
      {buttonData.buttonText}
    </button>
  );
};

export default HeaderButton;
